export default __webpack_public_path__ + "static/media/numbers.cb372885.png";